import LoginForm from './components/login-form';
import TeamMemberSelector from './components/team-member-selector';
import Comments from './components/comments';
import Pay from './components/pay';
import Team from './components/team';
import Invite from './components/invite';
import Calendar from './components/calendar';
import Bubble from './components/bubble';
import InfiniteScroll from './infinite-scroll';
import Cookies from 'js-cookie';
import ReactDOM from 'react-dom';
import React from 'react';
import moment from 'moment';
import "babel-polyfill";
import 'whatwg-fetch';
import Stream from './components/livestream/stream';

import {
    loadComments
}  from './components/comments/comments.actions';

let translations = {};

const Exanimo = {
    init(params) {
        translations = params.lang;
        this.CSRF = params.CSRF;
        this.userId = params.userId;
        this.braintreeToken = params.braintreeToken;
        this.route = params.route;
        this.userData = params.userData;

        this._modalContainer = document.getElementById('modal');

        this._trackMenuScroll();
        this._addDropDownToggle();
        this._initComments();
        this._initModals();
        this._initTimers();
        this._initCalendar();
        this._initBubble(params.bubbleData);
        this._resizeLarpTypeBoxes();
        this._transformTinyEditorContent();
        this._initLiveBroadcastsComponent();
        InfiniteScroll.init();
    },

    trans(key) {
        return translations[key] || key;
    },

    _trackMenuScroll() {
        window.addEventListener('scroll', this._trackScroll);
        this._trackScroll();
    },

    _addDropDownToggle() {
        let node = document.getElementsByClassName('profile-header')[0];

        if (!node) {
            return;
        }

        node.addEventListener('click', this._dropDownToggle.bind(this));
    },

    _trackScroll() {
        const menuNode = document.getElementById('menu');
        const appNode = document.getElementById('app');

        if (window.scrollY > 40) {
            menuNode.classList.add('detached');
            appNode.classList.add('menu-detached');
        } else {
            menuNode.classList.remove('detached');
            appNode.classList.remove('menu-detached');
        }
    },

    _dropDownToggle(e) {
        if (e.target.className.indexOf('dropdown-item') !== -1) {
            return;
        }

        let node = document.getElementById('dropdown-menu');

        if (node.style.display === 'block') {
            document.removeEventListener('click', this._trackMenuClose);
            node.style.display = 'none';
        } else {
            if (!this.sentNotify && parseInt(e.currentTarget.dataset.unread, 10) > 0) {
                this.sentNotify = true;

                this._notificationsRead();
            }
            document.addEventListener('click', this._trackMenuClose.bind(this));
            node.style.display = 'block';
        }
    },

    _initTimers() {
        this._triggerTimers();
        setInterval(this._triggerTimers, 5000);
    },

    _initCalendar() {
        const node = document.getElementById('calendar');

        if (!node) {
            return;
        }

        ReactDOM.render(
            <Calendar/>
            , node);
    },

    _triggerTimers() {
        const elements = document.getElementsByClassName('timer');

        if (!elements[0]) {
            return;
        }

        for (let i = 0; i < elements.length; i++) {

            const element = elements[i];

            const time = parseInt(element.dataset.time, 10);

            if (!time) {
                return;
            }

            element.innerHTML = moment.unix(time).fromNow() + '<br/>';
        }
    },

    _notificationsRead() {
        fetch(`/settings/notification_read/`,{
            method: 'GET',
            credentials: 'same-origin'
        }).catch((err) => {
            console.log(err);
        });
    },

    _trackMenuClose(e) {

        let headerNode = document.getElementsByClassName('profile-header')[0];

        if (headerNode && headerNode.contains(e.target)) {
            return;
        }

        let node = document.getElementById('dropdown-menu');
        node.style.display = 'none';

        document.removeEventListener('click', this._trackMenuClose);
    },

    _initComments() {
        let commentsNodeList = document.getElementsByClassName('comment-block');

        for (let i = 0; i < commentsNodeList.length; i++) {
            const node = commentsNodeList.item(i);

            loadComments({
                type: node.dataset.type,
                id: node.dataset.id
            });

            ReactDOM.render(
                <Comments
                    type={node.dataset.type}
                    id={parseInt(node.dataset.id, 10)}
                />
                , node);
        }
    },
    _initModals() {
        if (this.route === 'auth.login.get') {
            this.login();
        }

        if (this.route === 'teams.create') {
            this.teamModal();
        }
    },

    login() {
        let loginOpen = true;

        const close = function (e) {
            e.preventDefault();
            loginOpen = false;

            render(true);
        };

        const render = (init = false) => {
            ReactDOM.render(
                <LoginForm
                    open={loginOpen}
                    onClose={close}
                    init={init}
                />
                , this._modalContainer);
        };

        render();

        return false;
    },

    pay(el) {

        const tournamentId = parseInt(el.dataset.tournamentid, 10);
        const teamId = parseInt(el.dataset.teamid, 10);
        const price = parseInt(el.dataset.price, 10);

        let loginOpen = true;

        const close = function (e) {
            e.preventDefault();
            loginOpen = false;

            render();
        };

        const render = () => {
            ReactDOM.render(
                <Pay
                    open={loginOpen}
                    onClose={close}
                    personsCode={this.userData.person_identity_number}
                    address={this.userData.address}
                    name={this.userData.name}
                    braintreeToken={this.braintreeToken}
                    tournamentId={tournamentId}
                    teamId={teamId}
                    price={price}
                />
                , this._modalContainer);
        };

        render();

        return false;
    },

    teamModal(el) {

        const title = (el && el.dataset.title) || '';
        const teamId = (el && parseInt(el.dataset.teamid, 10)) || 0;

        let loginOpen = true;

        const close = function (e) {
            e.preventDefault();
            loginOpen = false;

            render();
        };

        const render = () => {
            ReactDOM.render(
                <Team
                    open={loginOpen}
                    onClose={close}
                    title={title}
                    teamId={teamId}
                />
                , this._modalContainer);
        };

        render();

        return false;
    },

    inviteModal(el) {

        const modalContainer = document.getElementById('modal');
        const teamId = parseInt(el.dataset.teamid, 10) || 0;

        let loginOpen = true;

        const close = function (e) {
            e.preventDefault();
            loginOpen = false;

            render();
        };

        const render = () => {
            ReactDOM.render(
                <Invite
                    open={loginOpen}
                    onClose={close}
                    teamId={teamId}
                />
                , modalContainer);
        };

        render();

        return false;
    },

    addPlayerModal(el) {

        const modalContainer = document.getElementById('modal');
        const tournamentId = parseInt(el.dataset.tournamentid, 10) || 0;

        let open = true;

        const close = function (e) {
            e.preventDefault();
            open = false;

            render();
        };

        const render = () => {
            ReactDOM.render(
                <Invite
                    open={open}
                    onClose={close}
                    tournamentId={tournamentId}
                    submitUrl={'/admin/tournaments/add-player'}
                />
                , modalContainer);
        };

        render();

        return false;
    },

    _initBubble(data) {

        if (!data || !data.enabled || Cookies.get('bubble_closed') === data.updated_at) {
            return;
        }

        const container = document.createElement('div');
        document.body.appendChild(container);

        ReactDOM.render(
            <Bubble
                title={data.title}
                url={data.url}
                updated={data.updated_at}
            />
            , container);
    },

    teamMemberSelect(el) {
        let teamData;
        let currentRoster;
        let timeSlotData;
        try {
            teamData = JSON.parse(el.dataset.myteams);
        } catch(e) {
            return;
        }

        try {
            currentRoster = JSON.parse(el.dataset.roster);
        } catch(e) {
        }

        try {
            timeSlotData = JSON.parse(el.dataset.timeslots);
        } catch(e) {
        }

        const rosterSize = parseInt(el.dataset.rostersize, 10);
        const tournamentId = parseInt(el.dataset.tournamentid, 10);
        const teamSelected = parseInt(el.dataset.team, 10) || 0;
        const timeSlotMax = parseInt(el.dataset.timeslotmax, 10) || 0;
        let open = true;

        const close = function (e) {
            e.preventDefault();
            open = false;

            render(true);
        };

        const render = (init = false) => {
            ReactDOM.render(
                <TeamMemberSelector
                    open={open}
                    onClose={close}
                    init={init}
                    teamData={teamData}
                    roster={currentRoster}
                    timeSlotData={timeSlotData}
                    rosterSize={rosterSize}
                    teamSelected={teamSelected}
                    tournamentId={tournamentId}
                    timeSlotMaxParticipants={timeSlotMax}
                />
                , this._modalContainer);
        };

        render();

        return false;
    },

    _resizeLarpTypeBoxes() {
        if (this.route !== 'about.larp') {
            return;
        }

        const mainContainers = document.querySelectorAll('.larp-type .main');
        let minHeight = 0;

        mainContainers.forEach(function (item) {
            let currentItemHeight = item.getBoundingClientRect().height;

            if (currentItemHeight > minHeight) {
                minHeight = currentItemHeight;
            }
        });

        mainContainers.forEach(function (item) {
            item.style.minHeight = minHeight + 'px';
        });
    },

    _transformTinyEditorContent() {
        if (this.route !== 'news.show' && this.route !== 'tournaments.show') {
            return;
        }

        const containers = document.querySelectorAll('.tiny-editor-content > p span[style*="width"][style*="height"]')

        containers.forEach(container => {
            if (container.querySelector('img')) {
                container.classList.add('has-img')
            }
        })

        let links = document.querySelectorAll(".tiny-editor-content a, .tournament-text a")

        for (let i = 0; i < links.length; i++) {
            var link = links[i];

            if (link.getAttribute("href") && link.hostname !== location.hostname) {
                link.target = "_blank"
            }
        }
    },

    _initLiveBroadcastsComponent() {
        let liveEl = document.getElementById('live');

        if (liveEl) {
            let streamsDataParsed = JSON.parse(liveEl.dataset.streams);

            ReactDOM.render(
                <Stream
                    streams={streamsDataParsed}
                    prefferedStream={liveEl.dataset.prefferedlang}
                    availableStreams={Object.keys(streamsDataParsed)}
                />,
                liveEl
            );
        }
    }
};

export default Exanimo;
